import { useAuth } from "@/features/auth/hooks/useAuth";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { SETTINGS_ACTION, SettingsSection } from "./SettingsSection";

const memberSince = (iso: string | null | undefined): string | null => {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime()) || d.getTime() === 0) return null;
  return d.toLocaleDateString("en-US", { month: "long", year: "numeric" });
};

export const UserProfileCard = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    await logout();
    navigate("/login");
  }, [logout, navigate]);

  if (!user) return null;
  const since = memberSince(user.created_at);

  return (
    <SettingsSection id="settings-account-profile" label="Account">
      <p className="font-display text-3xl leading-tight tracking-tight text-zinc-900">
        {user.full_name || "User"}
      </p>
      <p className="chat-ed-meta hero-mono !mt-1.5">
        {user.email}
        {since ? ` · member since ${since}` : ""}
      </p>
      <div className="mt-4">
        <button type="button" onClick={handleLogout} className={SETTINGS_ACTION}>
          Sign out
        </button>
      </div>
    </SettingsSection>
  );
};
